import { render, staticRenderFns } from "./clientCollectionLogin.vue?vue&type=template&id=b9d66878&"
import script from "./clientCollectionLogin.vue?vue&type=script&lang=js&"
export * from "./clientCollectionLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports